var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.46225 3.77199C4.67282 2.9461 2.7616 4.65672 3.38483 6.52641L5.13031 11.7629C5.18163 11.9168 5.18163 12.0832 5.13031 12.2372L3.38483 17.4736C2.7616 19.3433 4.67283 21.054 6.46225 20.2281L21.3388 13.362C22.5007 12.8257 22.5007 11.1743 21.3388 10.6381L6.46225 3.77199ZM4.80786 6.05207C4.60011 5.42884 5.23719 4.85863 5.83366 5.13393L20.7102 12L5.83367 18.8661C5.23719 19.1414 4.60011 18.5712 4.80786 17.948L6.54052 12.75H14.9999C15.4141 12.75 15.7499 12.4142 15.7499 12C15.7499 11.5858 15.4141 11.25 14.9999 11.25H6.5405L4.80786 6.05207Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.484c768b40d871340bffad903b90744a.svg";
export { ForwardRef as ReactComponent };